/**
 * Web.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApplicationOrdersGetByIdOrderItemResponse { 
    id?: string | null;
    label?: string | null;
    familyId?: string | null;
    subFamilyId?: string | null;
    quantity?: number | null;
    unitPrice?: number | null;
    totalPrice?: number | null;
}

